import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxIndexedDBModule } from 'ngx-indexed-db';

@NgModule({
  imports: [
    CommonModule,
    NgxIndexedDBModule
  ],
})
export class ArchModule {}
